import { render, staticRenderFns } from "./XpsjAll.vue?vue&type=template&id=61096d0d&scoped=true&"
import script from "./XpsjAll.vue?vue&type=script&lang=js&"
export * from "./XpsjAll.vue?vue&type=script&lang=js&"
import style0 from "./XpsjAll.vue?vue&type=style&index=0&id=61096d0d&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61096d0d",
  null
  
)

export default component.exports